// s90 (tog'a 2026-09-09, msg 1572 §21): skaner → qaysi jadvalga qo'shish TANLANADI → o'sha formaga tovar to'liq yuklanadi.
// tog‘a #2065 W1 (2026-09-15): endi YAGONA nusxa (AppLayout → GlobalScanListener; sarlavha tugmasi hodisa bilan ochadi), GET Residues/Scan —
// bir xil kod bir nechta tovarda bo‘lsa ro‘yxatdan tanlanadi; forma allaqachon ochiq bo‘lsa sahifa almashmaydi — tovar o‘sha formaga qo‘shiladi,
// aks holda forma ochiladi va tovar reestr navbati orqali BIR MARTA qo‘shiladi (avvalgi URL `scanProduct` + har formadagi pendingScan o‘rniga).
import React, { useEffect, useRef, useState } from "react"
import { Button, Input, Radio, Tag, Typography, message } from "antd"
import { ScanOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import Modal from "../modal/DraggableModal"
import { request } from "../../utils/config"
import { nonNeg } from "../../utils/nonNeg"   // tog'a #1952: son 0 dan past ko'rsatilmaydi
import { hasVisibleTarget, queueScanFor, ScanKind } from "./scanRegistry"
import type { ScanItem } from "./scanTypes"
import { useIsMainSystem } from "../../utils/mainSystem"   // tog'a #4100

type Target = "sale" | "purchase" | "order" | "returnSale" | "transfer" | "showcase"   // W3/W5 (2026-09-16)

export default function GlobalScanner({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useTranslation()
  const history = useHistory()
  const bm = useIsMainSystem()   // tog'a #4100: ro'yxatda tovar partiyasi faqat glavniy tizimda
  const [code, setCode] = useState("")
  const [busy, setBusy] = useState(false)
  const [items, setItems] = useState<ScanItem[]>([])
  const [hit, setHit] = useState<ScanItem | null>(null)
  const [batch, setBatch] = useState<string | undefined>(undefined)
  const [target, setTarget] = useState<Target>("sale")
  const inputRef = useRef<any>(null)

  useEffect(() => {
    if (open) { setCode(""); setItems([]); setHit(null); setBatch(undefined); setTimeout(() => inputRef.current?.focus?.(), 150) }
  }, [open])

  const chooseItem = (it: ScanItem) => {
    setHit(it)
    // skanerlangan kod partiya kodi bo'lsa — partiya avtomat tanlanadi
    setBatch(it.exactBatch || (it.batches?.length === 1 ? it.batches[0].batchNumber : undefined))
  }

  const lookup = async () => {
    const c = code.trim()
    if (!c) return
    setBusy(true)
    try {
      const r = await request({ url: "Residues/Scan", params: { code: c } })
      const list: ScanItem[] = r.data?.items || []
      setItems(list)
      if (list.length === 1) chooseItem(list[0])
      else { setHit(null); setBatch(undefined) }
    } catch (e: any) {
      setItems([]); setHit(null)
      message.warning(e?.response?.data?.message || t("scanNotFound", "Tovar topilmadi"))
    } finally { setBusy(false) }
  }

  const ochish = () => {
    if (!hit?.product?.id) return
    const kind: ScanKind = target
    queueScanFor(kind, { code: code.trim(), item: hit, batchNumber: batch, stock: Number(hit.total || 0) })
    onClose()
    if (hasVisibleTarget(kind)) return   // forma ochiq — sahifa va filtrlar saqlanadi
    // W3: qaytarish va perevod formalari ham nishon. URL naqshlari sahifalardan olingan:
    // returnSales — guruhlangan sahifa, forma drawer ichida (counterpartyId=null); transfers — forma KUN drawer’i ichida (selectDay).
    const bugun = new Date(Date.now() + 5 * 3600 * 1000).toISOString().slice(0, 10)
    const url = target === "sale" ? `/sales?counterpartyId=null&sale=add`
      : target === "purchase" ? `/purchases?documents=null&purchase=add`
      : target === "returnSale" ? `/returnSales?counterpartyId=null&returnSale=add`
      : target === "transfer" ? `/transfers?selectDay=${bugun}&transfer=add`
      : target === "showcase" ? `/showcases?counterpartyId=null&status=1&showcase=add`
      : `/orders?counterpartyId=null&order=add`
    history.push(url)
  }

  const p = hit?.product
  return (
    <Modal visible={open} onCancel={onClose} footer={null} width={560} zIndex={1050}
      title={<span><ScanOutlined /> {t("scannerTitle", "Сканер")}</span>}>
      <Input.Search ref={inputRef} size="large" value={code} onChange={(e) => setCode(e.target.value)} onSearch={lookup}
        data-scan-owner="scanner"
        loading={busy} enterButton={t("scanLookup", "Найти")} placeholder={t("scanPlaceholder", "Штрих-код / артикул / код партии — отсканируйте")} autoComplete="off" />
      {items.length > 1 && !hit && (
        <div style={{ marginTop: 12 }}>
          <Typography.Text strong>{t("scanPickTitle", { code: code.trim(), defaultValue: "Код {{code}}: выберите товар" })}</Typography.Text>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 6 }}>
            {items.map((it) => (
              <Button key={it.product.id} block style={{ height: "auto", textAlign: "left", whiteSpace: "normal", padding: "6px 10px" }} onClick={() => chooseItem(it)}>
                <b>{it.product.name}</b> {it.product.article ? <Tag>{it.product.article}</Tag> : null}{" "}
                {/* tog'a #4100: tovar partiyasi (yoki yagona qoldiqli partiya) — faqat glavniy tizimda */}
                {(() => { const pb = bm ? it.product.batchNumber || (it.batches?.length === 1 ? it.batches[0].batchNumber : "") : ""; return pb ? <Tag color="gold">{t("batchLbl", "Партия")}: {pb}</Tag> : null })()}
                <Tag color="purple">{t("scanMatch_" + it.matchType, it.matchType)}</Tag> {t("totalCount")}: <b>{nonNeg(it.total)}</b>
              </Button>
            ))}
          </div>
        </div>
      )}
      {p && hit && (
        <div style={{ marginTop: 14, padding: "10px 12px", border: "1px solid #e2e8f0", borderRadius: 10, background: "#f8fafc" }}>
          <div style={{ fontWeight: 700, fontSize: 15 }}>{p.name} {p.article ? <Tag>{p.article}</Tag> : null} {p.barCode ? <Tag color="blue">{p.barCode}</Tag> : null}</div>
          <div style={{ fontSize: 13, color: "#334155", marginTop: 4 }}>
            {t("salePriceUSD")}: <b>${Number(p.salePriceUSD || 0).toFixed(2)}</b> · {t("costPriceUSD")}: <b>${Number(p.costPriceUSD || 0).toFixed(2)}</b> · {t("totalCount")}: <b>{nonNeg(hit.total)}</b>
          </div>
          {Array.isArray(hit.batches) && hit.batches.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <Typography.Text type="secondary">{t("batchLbl", "Партия")}:</Typography.Text>{" "}
              <Radio.Group size="small" value={batch} onChange={(e) => setBatch(e.target.value)}>
                {hit.batches.slice(0, 12).map((b) => (
                  <Radio.Button key={b.purchaseId} value={b.batchNumber}>{b.batchNumber} · {b.amount}{b.warehouseName ? " · " + b.warehouseName : ""}</Radio.Button>
                ))}
              </Radio.Group>
            </div>
          )}
          <div style={{ marginTop: 12 }}>
            <Typography.Text strong>{t("scanTarget", "Qaysi jadvalga qo'shilsin?")}</Typography.Text>
            <div style={{ marginTop: 6 }}>
              <Radio.Group value={target} onChange={(e) => setTarget(e.target.value)} buttonStyle="solid">
                <Radio.Button value="sale">{t("saleCount", "Продажа")}</Radio.Button>
                <Radio.Button value="purchase">{t("gPurch", "Закупка")}</Radio.Button>
                <Radio.Button value="order">{t("orders", "Заказ")}</Radio.Button>
                <Radio.Button value="returnSale">{t("returnSale", "Возврат продажи")}</Radio.Button>
                <Radio.Button value="transfer">{t("transfer", "Перевод")}</Radio.Button>
                <Radio.Button value="showcase">{t("showcases", "Витрина")}</Radio.Button>
              </Radio.Group>
            </div>
          </div>
          <div style={{ marginTop: 12, textAlign: "right" }}>
            {items.length > 1 && <Button style={{ marginRight: 8 }} onClick={() => { setHit(null); setBatch(undefined) }}>{t("back", "Назад")}</Button>}
            <Button type="primary" size="large" onClick={ochish}>{t("scanOpen", "Открыть и добавить")}</Button>
          </div>
        </div>
      )}
      <div style={{ marginTop: 10, fontSize: 12, color: "#94a3b8" }}>{t("scanHint", "Skanerlang → tovar chiqadi → jadvalni tanlang → «Открыть»: forma ochiladi va tovar qatori to'liq ma'lumoti bilan qo'shiladi")}</div>
    </Modal>
  )
}
